import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import createCraIssue from "../CraManagement/createCraIssue.vue";

export default {
  name: 'sdvDiscrepancyModel',
  props: {
    sdvPayload: {
      type: Object,
      default: () => ({}),
    },
    fromTab: {
      type: String,
      default: 'dataSignal',
    },
  },
  components: {
    customModal,
    createCraIssue,
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      headerValues: {},
      reasonsList: [],
      showcreateIssueModal: false,
      selectedStudyId: "",
      selectedSiteId: "",
      // Local fields replace the old sdvPayload.discrepancyReason /
      // sdvPayload.sdvVerificationComments, since sdvPayload is now a
      // ReviewSDVCommand-shaped prop and shouldn't be mutated directly.
      discrepancyReason: "",
      comments: "",
      expectedValue: "",
    };
  },
  async mounted() {
    this.headerValues = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    await this.getReasons();
  },
  methods: {
    closeDisModal() {
      this.$emit('closeModal');
    },

    OpenIssue(question) {
      this.selectedStudyId =
        this.$route.query.studyId || store.getters.getStudyId;

      this.selectedSiteId =
        this.$route.query.siteId || store.getters.getSiteId;

      this.showcreateIssueModal = true;
    },

    async getReasons() {
      try {
        let url = `${this.baseurl}/stats-python/formstatistics/getalldiscrepancyreasons`;
        let response = await axios.get(url, this.headerValues);
        this.reasonsList = response.data;
      }
      catch (error) {
        console.log("error to get reasons...", error);
      }
    },

    // Fills the discrepancy details onto the ReviewSDVCommand payload
    // passed down from the parent, then submits it to reviewformsdvitem.
    // reason/expectedValue are shared across the batch; actualValue is
    // preserved per-item from what the parent already attached.
    async verifySourceData() {
      try {
        const payload = {
          ...this.sdvPayload,
          items: (this.sdvPayload.items || []).map(({ actualValue, ...item }) => ({
            ...item,
            comments: this.comments,
            discrepancy: {
              reason: this.discrepancyReason,
              expectedValue: this.isSingleItem ? this.expectedValue : "",
              actualValue: this.isSingleItem ? (actualValue || "") : "",
            },
          })),
        };

        await axios.put(
        `${this.baseurl}/forms/managesdv/reviewformsdvitem`,
          payload,this.headerValues
        );

        alert(this.$t('navigations.sdv completed successfully'));
        this.closeDisModal();
      }
      catch (error) {
        console.error("Error in verify source data:", error);
      }
    },
  },
  computed: {
    actualValueDisplay() {
      const items = this.sdvPayload?.items || [];
      return items.map(item => item.actualValue || '').join(', ');
    },
    isSingleItem() {
      return (this.sdvPayload?.items || []).length === 1;
    },
  },
};